import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AccountsFeatureHeaderModule } from '@mode/accounts/feature-header';
import { AccountsUiModule } from '@mode/accounts/ui';
import { ButtonComponent, HeaderComponent, IconComponent } from '@mode/capra';
import { ChartsDomainModule } from '@mode/charts/domain';
import { ChartsUiModule } from '@mode/charts/ui';
import { FileExportsUiDrawerComponent } from '@mode/file-exports/ui-drawer';
import { ReportViewerDomainModule } from '@mode/report-viewer/domain';
import { ReportViewerPdfExportFeatureDialogModule } from '@mode/report-viewer/pdf-export/feature-dialog';
import { DatasetGoogleFeatureDialogModule } from '@mode/dataset/google/feature-dialog';
import { ReportViewerUiModule } from '@mode/report-viewer/ui';
import { ReportsDomainModule } from '@mode/reports/domain';
import { SharedSchedulesDomainModule } from '@mode/shared/schedules/domain';
import { LoaderComponent, SharedUiModule } from '@mode/shared/ui';
import { SharedUtilDomModule } from '@mode/shared/util-js';
import { AnalyticsEvent, PAGE_CONTEXT } from '@mode/shared/util-segment';
import { ReportViewerFileExportsComponent } from './+ui/report-viewer-file-exports/report-viewer-file-exports.component';
import { ReportViewerComponent } from './+ui/report-viewer/report-viewer.component';
import { RootComponent } from './+ui/root/root.component';
import { SaveIndicatorComponent } from './+ui/save-indicator/save-indicator.component';
import { VizComponent } from './+ui/viz/viz.component';
import { NotebooksDomainModule, NotebookSecretService } from '@mode/notebooks/domain';
import { PublishModule } from '@mode/dataset/feature-publish';

const routes: Array<Route> = [
  {
    path: ':reportToken',
    component: RootComponent,
    children: [
      {
        path: 'runs/:reportRunToken',
        component: ReportViewerComponent,
      },
      {
        path: '',
        component: ReportViewerComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [
    RootComponent,
    ReportViewerComponent,
    SaveIndicatorComponent,
    VizComponent,
    ReportViewerFileExportsComponent,
  ],
  imports: [
    CommonModule,
    ReportViewerDomainModule,
    ReportsDomainModule,
    ChartsDomainModule,
    ChartsUiModule,
    RouterModule.forChild(routes),
    AccountsFeatureHeaderModule,
    DatasetGoogleFeatureDialogModule,
    SharedUiModule,
    AccountsUiModule,
    SharedUtilDomModule,
    ReportViewerUiModule,
    ButtonComponent,
    HeaderComponent,
    IconComponent,
    LoaderComponent,
    ReportViewerPdfExportFeatureDialogModule,
    SharedSchedulesDomainModule,
    FileExportsUiDrawerComponent,
    PublishModule,
    NotebooksDomainModule,
  ],
  providers: [{ provide: PAGE_CONTEXT, useValue: AnalyticsEvent.SubContext.ReportView }, NotebookSecretService],
})
export class ReportViewerShellModule {}
